<template>
	<div class="task-box"  v-if="body_show">
		<!-- 新版间隔 ⬇ -->
		<div class="t3-new" v-if="!is_main || cid>=5 && cid !=6">
			<div class="task-title">
				T3: 重塑职业目标
			</div>
			<!--  -->
			<div class="task_f p-task">
				<h3 class="label">我想要从事的目标行业是什么？<span>（如果不转行，请选择你当前的行业）</span></h3>
				<div  class="input-box">
					<van-cell-group class="grouping">
						<van-field :placeholder="!is_other?'请选择想要从事的目标行业':'请填写想要从事的目标行业'" v-model="profession"  :readonly="!is_other" @click="!is_other?pType(1):''" />
						<label v-show="!is_other" class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
					</van-cell-group>
				</div>
			</div>
			<!--  -->
				<div class="task_f">
					<h3 class="label">我想要从事的目标职位是什么？</h3>
					<div class="pr mt_reset2 mt">
						<div class="input-box">
							<div>
								<input v-model="job" type="text" placeholder="建议填写未来2-3年的目标职位" />
							</div>
						</div>
						<span class="float">{{ job.length }}/8</span>
					</div>
				</div>
			<!--  -->
			<div class="task_f clearfix">
				<h3 class="label">我希望在何时达成以上职业目标？</h3>
				<div  class="input-box mt">
					<van-cell-group class="grouping years-box">
						<van-field  v-model="years"  readonly  @click="pType(2)" />
						<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
					</van-cell-group>
					<div class="y">
						年
					</div>
					<van-cell-group class="grouping years-box">
						<van-field  v-model="months"  readonly  @click="pType(3)" />
						<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
					</van-cell-group>
					<div class="y">
						月
					</div>
				</div>
			</div>
			<!--  -->
			<div class="task_f clearfix">
				<h3 class="label">到那个时候，我希望我的职业收入水平到达</h3>
				<div class="pr mt_reset2 mt years-money-box">
					<div class="input-box">
						<div>
							<input v-model="income" type="text" placeholder="请填写年收入数字" />
						</div>
					</div>
					<span class="float">{{ income.length }}/3</span>
				</div>
				<div class="years-money-text mt">
					万元/年
				</div>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label">到那个时候，我希望我实现怎样的职业成就？</h3>
				<div class="input-mt mt_reset2">
					<div>
						<textarea v-model="achievement" placeholder="请简要描述，你希望实现的职业成就"></textarea>
					</div>
					<span class="float">{{ achievement.length }}/26</span>
				</div>
			</div>
			<!--  -->
			<div class="task_f clearfix">
				<h3 class="label">针对以上职业目标进行评估</h3>
				<div  class="input-box mt">
					<div class="y">
						爱干
					</div>
					<van-cell-group class="grouping years-box">
						<van-field  v-model="love"  readonly  @click="pType(4)" />
						<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
					</van-cell-group>
					<div class="y y-on">
						能干
					</div>
					<van-cell-group class="grouping years-box">
						<van-field  v-model="capable"  readonly  @click="pType(5)" />
						<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
					</van-cell-group>
				</div>
				<div  class="input-box mt2">
					<div class="y">
						值得干
					</div>
					<van-cell-group class="grouping years-box">
						<van-field  v-model="worth"  readonly  @click="pType(6)" />
						<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
					</van-cell-group>
				</div>
				<div class="task-submit-box">
					<div @click="pushData" :class="[isSubmitNew ? 'active' : '', 'submit-task','p-sub']">提交</div>
				</div>
			</div>
			<!--  -->
			<van-popup v-model="p_show" position="bottom">
				<van-picker v-if="p_type==1" show-toolbar :columns="profession_group" @cancel="cancel" @confirm="p_confirm" />
				<van-picker v-if="p_type==2" show-toolbar :columns="objYears['year']" @cancel="cancel" @confirm="p_confirm" />
				<van-picker v-if="p_type==3" show-toolbar :columns="objYears['months']" @cancel="cancel" @confirm="p_confirm" />
				<!-- 因为弹出数据一样，所以使用同一个picker -->
				<van-picker v-if="p_type==4 || p_type==5 || p_type==6" show-toolbar :columns="assess_group" @cancel="cancel" @confirm="p_confirm" />
			</van-popup>
		</div>
		<!-- 新版间隔 ⬆ -->
		<div v-else>
			<div class="task-title">
				T3: 职业路书设计
			</div>
			<div v-show="!isNextPage">
				<!--  -->
				<div class="task_f">
					<h3 class="label">职业目标：</h3>
					<div class="pr mt_reset2">
						<div class="input-box">
							<div>
								<input v-model="track" type="text" placeholder="请填写目标职位A" />
							</div>
						</div>
						<span class="float">{{ track.length }}/46</span>
					</div>
				</div>
				<!--  -->
				<div class="task_f">
					<h3 class="label mb">如果要达到你的职业目标，会经历哪5个里程碑</h3>
					<h3 class="label blank"><span class="noun normal">里程碑1</span><span class="accent">（尽量用<span @click="alertModule1 = true" class="noun">SMART</span>法则填写，序号越⼩距离当前越近）</span></h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="milestone" placeholder="请先写时间点（例：XX年XX月），再描述要达成的事件"></textarea>
						</div>
						<span class="float">{{ milestone.length }}/38</span>
					</div>
				</div>
				<!--  -->
				<div class="task_f">
					<h3 class="label blank"><span class="noun normal">里程碑2</span><span class="accent">（尽量用<span class="tangerine">SMART</span>法则填写，序号越⼩距离当前越近）</span></h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="milesttwo" placeholder="请先写时间点（例：XX年XX月），再描述要达成的事件"></textarea>
						</div>
						<span class="float">{{ milestone.length }}/38</span>
					</div>
				</div>
				<!--  -->
				<div class="task_f">
					<h3 class="label blank"><span class="noun normal">里程碑3</span><span class="accent">（尽量用<span class="tangerine">SMART</span>法则填写，序号越⼩距离当前越近）</span></h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="milestthree" placeholder="请先写时间点（例：XX年XX月），再描述要达成的事件"></textarea>
						</div>
						<span class="float">{{ milestone.length }}/38</span>
					</div>
				</div>
				<!--  -->
				<div class="task_f">
					<h3 class="label blank"><span class="noun normal">里程碑4</span><span class="accent">（尽量用<span class="tangerine">SMART</span>法则填写，序号越⼩距离当前越近）</span></h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="milestfour" placeholder="请先写时间点（例：XX年XX月），再描述要达成的事件"></textarea>
						</div>
						<span class="float">{{ milestone.length }}/38</span>
					</div>
				</div>
				<!--  -->
				<div class="task_f">
					<h3 class="label blank"><span class="noun normal">里程碑5</span><span class="accent">（尽量用<span class="tangerine">SMART</span>法则填写，序号越⼩距离当前越近）</span></h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="milestfive" placeholder="请先写时间点（例：XX年XX月），再描述要达成的事件"></textarea>
						</div>
						<span class="float">{{ milestone.length }}/38</span>
					</div>
				</div>
				<!--  -->
				<div class="task_f">
					<h3 class="label mb">针对以上里程碑路书的个人四项评估</h3>
					<div class="cell clearfix">
						<!-- 成就感 -->
						<van-cell-group class="grouping pull-left clearfix">
							<van-field v-model="ability" label="能力" @click="pickerType(1)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
						<!-- 价值感 -->
						<van-cell-group class="grouping pull-right clearfix">
							<van-field v-model="confidence" label="信心" @click="pickerType(2)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
					</div>
				</div>
				<div class="task_f">
					<h3 class="label mb">驱动</h3>
					<div class="cell clearfix">
						<!-- 成就感 -->
						<van-cell-group class="grouping pull-left clearfix">
							<van-field v-model="passion" label="激情" @click="pickerType(3)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
						<!-- 价值感 -->
						<van-cell-group class="grouping pull-right clearfix">
							<van-field v-model="integration" label="内在整合" @click="pickerType(4)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
					</div>
				</div>
				<div class="task-footer">
					<div @click="goNextPage" :class="[activeNextBtn ? 'active' : '', 'submit-task']">下一步</div>
				</div>
			</div>
			<div v-show="isNextPage">
				<div class="task_f">
					<h3 class="label">职业目标：</h3>
					<h3 class="label blank">职业目标</h3>
				</div>
				<div class="task_f">
					<h3 class="label blank">
						<span class="noun normal">如果要达到你的职业目标，会面对哪3个重要风险</span>
						<span class="accent">（并分别为每个风险出现的概率和危害度打个分）</span>
					</h3>
				</div>
				<!-- 风险1 -->
				<div class="task_f">
					<h3 class="label">风险1</h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="riskone" placeholder="请用一句话描述潜在风险和障碍"></textarea>
						</div>
						<span class="float">{{ riskone.length }}/38</span>
					</div>
				</div>
				<div class="task_f mt_reset2">
					<div class="cell clearfix">
						<!-- 成就感 -->
						<van-cell-group class="grouping pull-left clearfix">
							<van-field v-model="riskone_prob" label="概率" @click="pickerType(5)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
						<!-- 价值感 -->
						<van-cell-group class="grouping pull-right clearfix">
							<van-field v-model="riskone_density" label="危害度" @click="pickerType(6)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
					</div>
				</div>
				<!-- 风险2 -->
				<div class="task_f">
					<h3 class="label">风险2</h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="risktwo" placeholder="请用一句话描述潜在风险和障碍"></textarea>
						</div>
						<span class="float">{{ risktwo.length }}/38</span>
					</div>
				</div>
				<div class="task_f mt_reset2">
					<div class="cell clearfix">
						<!-- 成就感 -->
						<van-cell-group class="grouping pull-left clearfix">
							<van-field v-model="risktwo_prob" label="概率" @click="pickerType(7)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
						<!-- 价值感 -->
						<van-cell-group class="grouping pull-right clearfix">
							<van-field v-model="risktwo_density" label="危害度" @click="pickerType(8)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
					</div>
				</div>
				<!-- 风险3 -->
				<div class="task_f">
					<h3 class="label">风险3</h3>
					<div class="input-mt mt_reset2">
						<div>
							<textarea v-model="riskthree" placeholder="请用一句话描述潜在风险和障碍"></textarea>
						</div>
						<span class="float">{{ riskthree.length }}/38</span>
					</div>
				</div>
				<div class="task_f mt_reset2">
					<div class="cell clearfix">
						<!-- 成就感 -->
						<van-cell-group class="grouping pull-left clearfix">
							<van-field v-model="riskthree_prob" label="概率" @click="pickerType(9)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
						<!-- 价值感 -->
						<van-cell-group class="grouping pull-right clearfix">
							<van-field v-model="riskthree_density" label="危害度" @click="pickerType(10)" readonly />
							<label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
						</van-cell-group>
					</div>
				</div>
				<div class="task-submit-box">
					<div @click="isNextPage = false" class="active submit-task">上一步</div>
					<div @click="submitData" :class="[isSubmit ? 'active' : '', 'submit-task']">提交</div>
				</div>
			</div>


			<!-- 弹出内容1 -->
			<van-popup class="explain" v-model="alertModule1">
				<div>
					<h2>SMART</h2>
					<div class="pps">
						<p class="module-xd">制定目标的SMART法则</p>
						Specific具体性：目标是具体的，不泛泛；Measurable可衡量：目标可衡量，有量化指标衡量是否达成；Attainable可实现：目标可达成而且有挑战性，避免太高或太低；Relevant相关性：目标和自身优势、内驱相关；Time-bound有时限：目标有明确的截止期限；
					</div>
				</div>
			</van-popup>
			<!-- 选择 -->
			<van-popup v-model="picker_show" position="bottom">
				<!-- 成就感1 -->
				<van-picker :item-height="50" v-show="picker_type==1" show-toolbar :default-index="ability.length>0?(parseInt(ability)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<!-- 价值感1 -->
				<van-picker :item-height="50" v-show="picker_type==2" show-toolbar :default-index="confidence.length>0?(parseInt(confidence)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<!-- 成就感2 -->
				<van-picker :item-height="50" v-show="picker_type==3" show-toolbar :default-index="passion.length>0?(parseInt(passion)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<!-- 价值感2 -->
				<van-picker :item-height="50" v-show="picker_type==4" show-toolbar :default-index="integration.length>0?(parseInt(integration)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />

				<van-picker :item-height="50" v-show="picker_type==5" show-toolbar :default-index="riskone_prob.length>0?(parseInt(riskone_prob)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<van-picker :item-height="50" v-show="picker_type==6" show-toolbar :default-index="riskone_density.length>0?(parseInt(riskone_density)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<van-picker :item-height="50" v-show="picker_type==7" show-toolbar :default-index="risktwo_prob.length>0?(parseInt(risktwo_prob)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<van-picker :item-height="50" v-show="picker_type==8" show-toolbar :default-index="risktwo_density.length>0?(parseInt(risktwo_density)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<van-picker :item-height="50" v-show="picker_type==9" show-toolbar :default-index="riskthree_prob.length>0?(parseInt(riskthree_prob)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
				<van-picker :item-height="50" v-show="picker_type==10" show-toolbar :default-index="riskthree_density.length>0?(parseInt(riskthree_density)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
			</van-popup>
		</div>
	</div>
</template>
<script>
	import { getroadbookdata, updateroadbookdata } from "@/api/course"
	import { getStorage, setStorage,isMain } from "@/utils/tools"
	import {
  shareCon
} from "@/utils/wxconfig";
	export default {
		data(){
			return {
				body_show:false,
				arrow: false,
				isSubmit: false,
				isNextPage: false,
				activeNextBtn: false,
				//
				alertModule1: false,
				//
				picker_show: false,
				picker_type: 0,
				// picker
				ability: "",
				confidence: "",
				integration: "",
				passion: "",
				//
				track: "",
				milestone: "",
				milesttwo: "",
				milestthree: "",
				milestfour: "",
				milestfive: "",
				//
				riskone: "",
				riskone_prob: "",
				riskone_density: "",
				risktwo: "",
				risktwo_prob: "",
				risktwo_density: "",
				riskthree: "",
				riskthree_prob: "",
				riskthree_density: "",
				//
				group_: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
				// 新版参数
				cid:'',
				arrow:false,
				p_show:false,
				p_type:0,
				profession:'',
				job:'',
				years:'',
				months:'',
				income:'',
				achievement:'',
				profession_group:[],
				love:null,
				capable:null,
				worth:null,
				objYears:{
					year:[],
					months:[1,2,3,4,5,6,7,8,9,10,11,12]
				},
				assess_group:[1,2,3,4,5,6,7,8,9,10],
				is_other:false,
				isSubmitNew:false
			}
		},
		computed: {
			is_main(){
				return isMain()
			}
		},
		methods: {
			// 选择框退出
      cancel(data) {
				this.picker_show = false;
				this.p_show = false;
      },
      // 弹出选择框
      confirm(data) {
        if (this.picker_type == 1) {
          this.ability = data;
        } else if (this.picker_type == 2) {
          this.confidence = data;
        } else if (this.picker_type == 3) {
          this.passion = data;
        } else if (this.picker_type == 4) {
          this.integration = data;
        } else if (this.picker_type == 5) {
        	this.riskone_prob = data;
        } else if (this.picker_type == 6) {
        	this.riskone_density = data;
        } else if (this.picker_type == 7) {
        	this.risktwo_prob = data;
        } else if (this.picker_type == 8) {
        	this.risktwo_density = data;
        } else if (this.picker_type == 9) {
        	this.riskthree_prob = data;
        } else if (this.picker_type == 10) {
        	this.riskthree_density = data;
        }

        this.picker_show = false;

			},
			p_confirm(data){
				if (this.p_type == 1) {
          this.profession = data;
        }else if(this.p_type == 2){
					this.years = data;
				}else if(this.p_type == 3){
					this.months = data;
				}else if(this.p_type == 4){
					this.love = data;
				}else if(this.p_type == 5){
					this.capable = data;
				}else if(this.p_type == 6){
					this.worth = data;
				}
				this.p_show = false;
			},
      submitData(){
				// 新版判断是否是第四期往后
				if(!this.is_main || this.cid>=5 && this.cid!=6){
					if(!this.isSubmitNew){
						return
					}
					this.pushData();
				}else{
					if(!this.isSubmit){
						return
					}
					this.commitData();
				}
      },
      commitData(){
      	let q = this.$route.query;
      	updateroadbookdata({
      		cid: q.cid,
					cpid: q.pid,
					cptid: q.id,
					iscreate: 1,
					type: "taskthree",
					track: this.track,
					milestone:this.milestone,
					milesttwo: this.milesttwo,
					milestthree: this.milestthree,
					milestfour: this.milestfour,
					milestfive: this.milestfive,
					riskone: this.riskone,
					risktwo: this.risktwo,
					riskthree: this.riskthree,
					ability: this.ability,
					passion: this.passion,
					confidence: this.confidence,
					integration: this.integration,
					riskone_prob: this.riskone_prob,
					risktwo_prob: this.risktwo_prob,
					riskthree_prob: this.riskthree_prob,
					riskone_density: this.riskone_density,
					risktwo_density: this.risktwo_density,
					riskthree_density: this.riskthree_density
      	})
      	.then((data) => {
      		let d = data;
          let q = this.$route.query;
          if(d.bot_done_status==2 && d.pmq_done_status ==1){
						this.$router.push({
							path: "/project3_eggs",
							query: {
								cid: q.cid
							}
						});
					}else if(d.bot_done_status==2 && d.pmq_done_status ==2){
						this.$router.push({
							path: "/project_report",
							query: {
								cid: q.cid,
								cpid: q.pid,
								type: "developpath"
							}
						});
					}
      	})
			},
			// 新版
      pushData(){
      	let q = this.$route.query;
      	updateroadbookdata({
      		cid: q.cid,
					cpid: q.pid,
					cptid: q.id,
					iscreate: 1,
					type: "taskthree",
					profession:this.profession,
					job:this.job,
					years:this.years,
					months:this.months,
					income:this.income,
					achievement:this.achievement,
					love:this.love,
					capable:this.capable,
					worth:this.worth,
      	})
      	.then((data) => {
      		let d = data;
          let q = this.$route.query;
          if(d.bot_done_status==2 && d.pmq_done_status ==1){
						this.$router.push({
							path: "/project3_eggs",
							query: {
								cid: q.cid
							}
						});
					}else if(d.bot_done_status==2 && d.pmq_done_status ==2){
						this.$router.push({
							path: "/project_report",
							query: {
								cid: q.cid,
								cpid: q.pid,
								type: "developpath"
							}
						});
					}
      	})
      },
			pickerType(type){
				this.picker_type = type;
        this.picker_show = true;
			},
			pType(type){
				this.p_type = type;
        this.p_show = true;
			},
			goNextPage(){
				if(!this.activeNextBtn){
					return
				}
				this.isNextPage = true;
			},
			pullData(){
				getroadbookdata({
          cid: this.$route.query.cid,
          type: "taskthree"
        })
				.then((data) => {
					this.body_show = true;
					// 10003
					if(typeof data === 'string'){
						let index = data.lastIndexOf('/');
						let path = data.slice(index);
						this.$router.push(path);
					}
					// 往下走
					this.cid = this.$route.query.cid;
					// 判断cid是否大于等于5(第四期往后)
					if(!this.is_main || this.$route.query.cid>=5 && this.$route.query.cid!=6){
						this.handleForTime();
						for(let i=0;i<data.data.profession_list.length;i++){
							this.profession_group.push(data.data.profession_list[i].name);
						}
						let {
							profession,
							job,
							years,
							months,
							income,
							achievement,
							love,
							capable,
							worth
						} = data.data;
						if(
							profession,
							job,
							years,
							months,
							income,
							achievement,
							love,
							capable,
							worth
						){
							// 设置服务器已提交的数据
							this.setDataVal(true, data.data);
						}else{
							this.setDataVal(false);
						}
					}else{
						let {
							ability,
							confidence,
							integration,
							milestfive,
							milestfour,
							milestone,
							milestthree,
							milesttwo,
							passion,
							riskone,
							riskone_density,
							riskone_prob,
							riskthree,
							riskthree_density,
							riskthree_prob,
							risktwo,
							risktwo_density,
							risktwo_prob,
							track
						} = data.data;
						if(
							ability,
							confidence,
							integration,
							milestfive,
							milestfour,
							milestone,
							milestthree,
							milesttwo,
							passion,
							riskone,
							riskone_density,
							riskone_prob,
							riskthree,
							riskthree_density,
							riskthree_prob,
							risktwo,
							risktwo_density,
							risktwo_prob,
							track
						){
							// 设置服务器已提交的数据
							this.setDataVal(true, data.data);
						}else{
							this.setDataVal(false);
						}
					}
				})
			},
			setDataVal(bool, d){
				let path = this.$route.path;
				// 判断cid大于五，第四期往后
				if(!this.is_main || this.cid>=5 && this.cid!=6){
					this.profession = bool ? d.profession : getStorage(path, 'profession') || '';
					this.job = bool ? d.job : getStorage(path, 'job') || '';
					this.years = bool ? d.years : getStorage(path, 'years') || '';
					this.months = bool ? d.months : getStorage(path, 'months') || '';
					this.income = bool ? d.income : getStorage(path, 'income') || '';
					this.achievement = bool ? d.achievement : getStorage(path, 'achievement') || '';
					this.love = bool ? d.love : getStorage(path, 'love') || '';
					this.capable = bool ? d.capable : getStorage(path, 'capable') || '';
					this.worth = bool ? d.worth : getStorage(path, 'worth') || '';
					this.changeNewState();
				}else{
					// 第一页
					this.ability = bool ? d.ability : getStorage(path, 'ability') || '';
					this.confidence = bool ? d.confidence : getStorage(path, 'confidence') || '';
					this.integration = bool ? d.integration : getStorage(path, 'integration') || '';
					this.milestfive = bool ? d.milestfive : getStorage(path, 'milestfive') || '';
					this.milestfour = bool ? d.milestfour : getStorage(path, 'milestfour') || '';
					this.milestone = bool ? d.milestone : getStorage(path, 'milestone') || '';
					this.milestthree = bool ? d.milestthree : getStorage(path, 'milestthree') || '';
					this.milesttwo = bool ? d.milesttwo : getStorage(path, 'milesttwo') || '';
					this.passion = bool ? d.passion : getStorage(path, 'passion') || '';
					this.track = bool ? d.track : getStorage(path, 'track') || '';
					// 第二页
					this.riskone = bool ? d.riskone : getStorage(path, 'riskone') || '';
					this.riskone_density = bool ? d.riskone_density : getStorage(path, 'riskone_density') || '';
					this.riskone_prob = bool ? d.riskone_prob : getStorage(path, 'riskone_prob') || '';
					this.riskthree = bool ? d.riskthree : getStorage(path, 'riskthree') || '';
					this.riskthree_density = bool ? d.riskthree_density : getStorage(path, 'riskthree_density') || '';
					this.riskthree_prob = bool ? d.riskthree_prob : getStorage(path, 'riskthree_prob') || '';
					this.risktwo = bool ? d.risktwo : getStorage(path, 'risktwo') || '';
					this.risktwo_density = bool ? d.risktwo_density : getStorage(path, 'risktwo_density') || '';
					this.risktwo_prob = bool ? d.risktwo_prob : getStorage(path, 'risktwo_prob') || '';
					// 判断时候允许下一页
					this.changeNextState();
					this.changeSubmitState();
				}
			},
			changeNextState(){
				if(
					this.ability &&
					this.confidence &&
					this.integration &&
					this.milestfive &&
					this.milestfour &&
					this.milestone &&
					this.milestthree &&
					this.milesttwo &&
					this.passion &&
					this.track
				){
					this.activeNextBtn = true;
				}else{
					this.activeNextBtn = false;
				}
			},
			changeSubmitState(){
				if(
					this.riskone &&
					this.riskone_density &&
					this.riskone_prob &&
					this.riskthree &&
					this.riskthree_density &&
					this.riskthree_prob &&
					this.risktwo &&
					this.risktwo_density &&
					this.risktwo_prob
				){
					this.isSubmit = true;
				}else{
					this.isSubmit = false;
				}
			},
			// 新版
			changeNewState(){
				if(
					this.profession &&
					this.job &&
					this.years &&
					this.months &&
					this.income &&
					this.achievement &&
					this.love &&
					this.capable &&
					this.worth
				){
					this.isSubmitNew = true;
				}else{
					this.isSubmitNew = false;
				}
			},
			setTitle() {
        let title = this.$route.query.name;
        document.title = decodeURI(title);
			},
			// 循环得到时间数据（从2019-2035）
      handleForTime() {
        var year = [];
        var myDate = new Date(); //获取系统当前时间
        for (var i = myDate.getFullYear(); i <= 2035; i++) {
          year.push(i);
        }
        this.objYears['year'] = year
      },
		},
		created(){
			this.pullData();
			this.setTitle();
			shareCon("course",this);
		},
		watch: {
			track(curVal, oldVal){
				if (curVal.length > 46) {
          this.track = curVal.slice(0, 46);
          this.$toast('最多只能输入46个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'track', curVal);
        };
        this.changeNextState();
			},
			milestone(curVal, oldVal){
				if (curVal.length > 38) {
          this.milestone = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'milestone', curVal);
        };
        this.changeNextState();
			},
			milesttwo(curVal, oldVal){
				if (curVal.length > 38) {
          this.milesttwo = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'milesttwo', curVal);
        };
        this.changeNextState();
			},
			milestthree(curVal, oldVal){
				if (curVal.length > 38) {
          this.milestthree = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'milestthree', curVal);
        };
        this.changeNextState();
			},
			milestfour(curVal, oldVal){
				if (curVal.length > 38) {
          this.milestfour = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'milestfour', curVal);
        };
        this.changeNextState();
			},
			milestfive(curVal, oldVal){
				if (curVal.length > 38) {
          this.milestfive = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'milestfive', curVal);
        };
        this.changeNextState();
			},
			ability(curVal, oldVal){
				if (curVal.length > 5) {
          this.ability = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'ability', curVal);
        };
        this.changeNextState();
			},
			confidence(curVal, oldVal){
				if (curVal.length > 5) {
          this.confidence = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'confidence', curVal);
        };
        this.changeNextState();
			},
			passion(curVal, oldVal){
				if (curVal.length > 5) {
          this.passion = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'passion', curVal);
        };
        this.changeNextState();
			},
			integration(curVal, oldVal){
				if (curVal.length > 5) {
          this.integration = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'integration', curVal);
        };
        this.changeNextState();
			},
			// 第二页
			riskone(curVal, oldVal){
				if (curVal.length > 38) {
          this.riskone = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'riskone', curVal);
        };
        this.changeSubmitState();
			},
			risktwo(curVal, oldVal){
				if (curVal.length > 38) {
          this.risktwo = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'risktwo', curVal);
        };
        this.changeSubmitState();
			},
			riskthree(curVal, oldVal){
				if (curVal.length > 38) {
          this.riskthree = curVal.slice(0, 38);
          this.$toast('最多只能输入38个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'riskthree', curVal);
        };
        this.changeSubmitState();
			},
			riskone_density(curVal, oldVal){
				if (curVal.length > 5) {
          this.riskone_density = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'riskone_density', curVal);
        };
        this.changeSubmitState();
			},
			riskone_prob(curVal, oldVal){
				if (curVal.length > 5) {
          this.riskone_prob = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'riskone_prob', curVal);
        };
        this.changeSubmitState();
			},
			risktwo_density(curVal, oldVal){
				if (curVal.length > 5) {
          this.risktwo_density = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'risktwo_density', curVal);
        };
        this.changeSubmitState();
			},
			risktwo_prob(curVal, oldVal){
				if (curVal.length > 5) {
          this.risktwo_prob = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'risktwo_prob', curVal);
        };
        this.changeSubmitState();
			},
			riskthree_density(curVal, oldVal){
				if (curVal.length > 5) {
          this.riskthree_density = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'riskthree_density', curVal);
        };
        this.changeSubmitState();
			},
			riskthree_prob(curVal, oldVal){
				if (curVal.length > 5) {
          this.riskthree_prob = curVal.slice(0, 5);
          this.$toast('最多只能输入5个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'riskthree_prob', curVal);
        };
        this.changeSubmitState();
			},
			// 新版
			profession(curVal, oldVal){
				if (curVal.length > 8) {
          this.profession = curVal.slice(0, 8);
          this.$toast('最多只能输入8个字。/(ㄒoㄒ)/~~');
        } else {
					if(this.profession == '其他'){
						this.is_other = true;
					}
          setStorage(this.$route.path, 'profession', curVal);
        };
        this.changeNewState();
			},
			job(curVal, oldVal){
				if (curVal.length > 8) {
          this.job = curVal.slice(0, 8);
          this.$toast('最多只能输入8个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'job', curVal);
        };
        this.changeNewState();
			},
			income(curVal, oldVal){
				if (curVal.length > 3) {
          this.income = curVal.slice(0, 3);
          this.$toast('最多只能输入3个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'income', curVal);
        };
        this.changeNewState();
			},
			achievement(curVal, oldVal){
				if (curVal.length > 26) {
          this.achievement = curVal.slice(0, 26);
          this.$toast('最多只能输入26个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'achievement', curVal);
        };
        this.changeNewState();
			},
			years(curVal, oldVal){
        setStorage(this.$route.path, 'years', curVal);
        this.changeNewState();
			},
			months(curVal, oldVal){
        setStorage(this.$route.path, 'months', curVal);
        this.changeNewState();
			},
			love(curVal, oldVal){
        setStorage(this.$route.path, 'love', curVal);
        this.changeNewState();
			},
			capable(curVal, oldVal){
        setStorage(this.$route.path, 'capable', curVal);
        this.changeNewState();
			},
			worth(curVal, oldVal){
        setStorage(this.$route.path, 'worth', curVal);
        this.changeNewState();
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
	.tangerine{
		color: #EB5032;
	}
	.grouping {
	  margin-top: 20px;
	  width: 280px
	}
	.module-xd{
		font-size: changeRem(0.56)+px;
    color: #666;
    margin-top: changeRem(0.92)+px;
	}
	.t3-new{
		.p-sub{
			margin: 0 auto;
		}
		.task_f{
			margin-top: 30px;
			.label{
				line-height: 42px;
			}
			.mt{
				margin-top: 12px;
			}
			.mt2{
				margin-top: 30px;
			}
			.years-money-box{
				width: 320px;
				float: left;
			}
			.years-money-text{
				margin-left: 20px;
				float: left;
				font-size: 26px;
				color: #333;
				line-height: 70px;
			}
			.input-box{
				background: transparent;
				padding-left: 0;
				font-size: 0;
				.grouping{
					margin-top: 0;
					width: auto;
				}
				.grouping.years-box{
					width: 144px;
					float: left;
				}
				.y{
					width: 100px;
					float: left;
					font-size: 26px;
					padding-left: 8px;
					color: #333;
					line-height: 70px;
				}
				.y.y-on{
					margin-left:40px;
				}
				input{
					padding-left: 20px;
					font-size: 26px;
				}
			}
		}
		.task_f.p-task{
			margin-top: 40px;
			.label{
				span{
					font-size: 24px;
					color: #666;
				}
			}
			.input-box{
				margin-top: 8px;
			}
		}
	}
</style>
